module.exports = __webpack_public_path__ + "img/acid_mist.4e57910d.png";